import React from 'react';
import MALImporter from './MALImporter';

const MALImportModal = ({ onClose, onImportComplete }) => {
  // Stop propagation for modal content clicks to prevent closing
  const handleContentClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div className="note-popup-overlay" onClick={onClose}>
      <div className="note-popup" onClick={handleContentClick} style={{ maxWidth: '600px' }}>
        <div className="note-popup-header">
          <h4>Import from MyAnimeList</h4>
          <button className="close-popup-btn" onClick={onClose}>×</button>
        </div>
        <div className="note-popup-content">
          <MALImporter onImportComplete={onImportComplete} />
        </div>
      </div>
    </div>
  );
};

export default MALImportModal;